import { PdMarkdownView } from "./pd-markdown-view/PdMarkdownView.js";
//#region src/pd-markdown-view/pd-markdown-view.ts
var tag = "pd-markdown-view";
if (!customElements.get(tag)) customElements.define(tag, PdMarkdownView);
//#endregion
export { PdMarkdownView };
